export const videoQueryParam = 'v'
export const exIdQueryParam = 'exid'
